<template>
    <apexchart
        ref="lineChart"
        class="line-chart"
        width="100%"
        type="line"
        :options="options"
        :series="series"
    />
</template>

<script>

export default {
    name: 'lineChart',

    props: {
        data: {
            type: Array,
            default: () => []
        },
    },

    mounted() {
        if(this.data.length){
            this.createChart();
        }
    },

    beforeDestroy(){
        this.destroyChart();
    },

    data() {
        return {
            series: [],
            options: {},
        };
    },

    watch: {
        data(val) {
            this.createChart();
        },
    },

    methods: {
        createChart() {
            this.series = [{
                name: this.$t('general.sales'),
                data: this.data.map(item => Money.parse(item.total).toFormat('0.00'))
            }];

            this.options = {
                labels: this.data.map(item => moment(item.date).format('D MMM')),
                chart: {
                    height: 500,
                    type: 'area',
                    zoom: {
                        autoScaleYaxis: true
                    }
                },
                dataLabels: {
                    enabled: false
                },
                stroke: {
                    curve: 'smooth'
                },
                xaxis: {
                    type: 'datetime',
                },
                tooltip: {
                    x: {
                        format: 'D MMM'
                    },
                },
                fill: {
                    type: 'gradient',
                    gradient: {
                        shadeIntensity: 0.3,
                        opacityFrom: 0.2,
                        opacityTo: 0.9,
                        stops: [0, 100]
                    }
                },
                stroke: {
                    width: 2
                }
            };
        },

        destroyChart() {
            if(this.$refs.lineChart) {
                this.$refs.lineChart.destroy()
            }
        }
    }
};
</script>

<style lang="scss" scoped>
.line-chart {
    max-width: 100%;
    max-height: 100%;
}
</style>
